<script>
export default {
  name: 'ContactsSidebar',
  computed: {
    collection() {
      return this.$store.getters['contacts/collection']
    },
    loading() {
      return this.$store.getters['contacts/isCollectionLoading']
    }
  }
}
</script>
<template>
  <div class="page-sidebar contacts-sidebar">
    <b-loading
      v-if="loading"
      :is-full-page="false"
      :active="loading"
    />
    <div v-else>
      <div
        v-for="(item, index) in collection"
        :key="index"
        class="page-sidebar__category"
      >
        <h3
          v-if="item.title"
          class="page-sidebar__category-title"
        >
          {{ item.title }}
        </h3>
        <div class="page-sidebar__category-content">
          <router-link
            v-for="office in item.offices"
            :key="`${index}_${office.slug}`"
            :to="{
              name: 'Contacts',
              params: {
                slug: office.slug
              }
            }"
            class="page-sidebar__category-link"
            :disabled="!office.active"
            :class="{
              'page-sidebar__category-link--disabled': !office.active
            }"
          >
            {{ office.name }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>